import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/manage/Active';
const options = { sort: sortOptions.dispatchedDate };

export const useActiveFilterStore = defineStore('activeFilterStore', {
  state: () => createBaseFilterState(options),
  actions: createFilterActions(filterAPI, options),
  getters: createFilterGetters(),
});
